var render, staticRenderFns
import script from "./ListSkeleton.vue?vue&type=script&lang=ts&"
export * from "./ListSkeleton.vue?vue&type=script&lang=ts&"
import style0 from "./ListSkeleton.vue?vue&type=style&index=0&id=143611cc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports